import IconButton from "@mui/material/IconButton";
import TablePagination from "@mui/material/TablePagination";
import * as React from "react";
import swal from "sweetalert";
import {
  CreateCategoryToDimenssionMap,
  GetAllCategoryToDimenssionMap,
  UpdateCategoryToDimenssionMap,
} from "../../../axios";
import {
  AddIcon,
  BreadCrumbs,
  FormTextInput,
  Modal,
  NodataFound,
  SearchMappingTable,
} from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import "../../../styles/tablepagination.css";
import { default as Strings } from "../../../translations";
import { isAuthorizedFunc } from "../../../utils";
import {
  CREATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING,
  UPDATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING,
} from "../../../utils/constants";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@mui/icons-material";
import CreateCategoryDimenssionMappingForm from "../../../forms/Masters/CreateCategoryDimessionMappingForm/CreateCategoryDimenssionMappingForm";

export default function SearchCategoryToDimenssionMapping() {
  const searchTitle = Strings["ItemCategoryDimenssionMapping.searchMapingDimenssionTitle"];
  const actionLabel = Strings["RoleFunctionMapping.TableHead.action"];
  const categoryLabel = Strings["ItemCategoryDimenssionMapping.TableHead.category"];
  const dimensionLabel = Strings["ItemCategoryDimenssionMapping.TableHead.dimenssion"];

  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [currentType, setCurrentType] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setMessage] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalData, setTotalData] = React.useState(0);
  const [isAdd, setAdd] = React.useState(true);
  const [isUpdate, setIsUpdate] = React.useState(true);
  const [searchValue, setSearchValue] = React.useState({ value: "", error: false, success: false });

  // Authorization
  React.useEffect(() => setAdd(isAuthorizedFunc(CREATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING)), []);
  React.useEffect(() => setIsUpdate(isAuthorizedFunc(UPDATE_ITEM_CATEGORY_TO_SUB_CATEGORY_MAPPING)), []);

  const paths = [
    { name: Strings["MasterConfigurationText"], path: "master-configuration" },
    { name: Strings["ItemCategoryDimenssionMapping"] },
  ];

  const mapableData = [
    { dataKey: "category_name", title: categoryLabel },
    { dataKey: "dimenssion", title: dimensionLabel },
    { dataKey: "category_id", title: actionLabel, isAction: true },
  ];

  const getAllCategoryDimenssionMap = React.useCallback(() => {
    let isMounted = true;
    setLoading(true);
    GetAllCategoryToDimenssionMap(rowsPerPage, page, searchValue.value)
      .then((res) => {
        if (!isMounted) return;
        const mappedRows = res.data.data.map((row) => ({
          category_name: row.name || row.category_name || "",
          dimenssion: row.dimensions?.map((d) => d.name).join(", ") || "",
          category_id: row.id,
        }));
        setRows(mappedRows);
        setTotalData(res.data.total);
      })
      .catch(() => { })
      .finally(() => { if (isMounted) setLoading(false); });

    return () => { isMounted = false; };
  }, [rowsPerPage, page, searchValue.value]);

  React.useEffect(() => {
    getAllCategoryDimenssionMap();
  }, [getAllCategoryDimenssionMap]);

  const createCategoryToDimenssion = (formData) => {
    setLoading(true);
    CreateCategoryToDimenssionMap(formData)
      .then(() => {
        swal("Success!", "Created Successfully", "success");
        handleModalClose();
        getAllCategoryDimenssionMap();
      })
      .catch((e) => setMessage(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const updateCategoryToDimenssion = (formData) => {
    setLoading(true);
    UpdateCategoryToDimenssionMap(formData)
      .then(() => {
        swal("Success!", "Updated Successfully", "success");
        handleModalClose();
        getAllCategoryDimenssionMap();
      })
      .catch((e) => setMessage(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const openAddModal = () => setIsOpen(true);

  const handleModalClose = () => {
    setMessage(null);
    setIsOpen(false);
  };
  const handleSelectBtn = (btn) => setClickedBtn(btn);

  const selectModal = () => (
    <CreateCategoryDimenssionMappingForm
      errorMessage={errorMessage}
      setMessage={setMessage}
      handleResultData={clickedBtn === "add" ? createCategoryToDimenssion : updateCategoryToDimenssion}
      actionType={clickedBtn}
      initialValue={clickedBtn === "edit" ? currentType : {}}
      handleModalClose={handleModalClose}
    />
  );

  const handleChangeEdit = (rowData) => {
    const mappedData = {
      ...rowData,
      dimenssion: Array.isArray(rowData?.properties)
        ? rowData?.dimenssion.map((p) => ({
          id: p?.id,
          name: p?.name
        }))
        : typeof rowData?.dimenssion === "string"
          ? rowData.dimenssion
            .split(",")
            .map((prop) => prop.trim())
            .filter((prop) => prop)
            .map((prop) => ({ id: null, name: prop }))
          : [],
    };

    setCurrentType(mappedData);
    handleSelectBtn("edit");
    setIsOpen(true);
    openAddModal();
  };

  const handleSearch = (searchData) => {
    setSearchValue(searchData);
    if (!searchData.value) getAllCategoryDimenssionMap();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getAllCategoryDimenssionMap();
  };

  function CustomTablePaginationActions({ count, page, rowsPerPage, onPageChange }) {
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    return (
      <div style={{ flexShrink: 0, marginLeft: "1rem" }}>
        <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0} aria-label="first page">
          <FirstPage />
        </IconButton>
        <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0} aria-label="previous page">
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= lastPage} aria-label="next page">
          <KeyboardArrowRight />
        </IconButton>
        <IconButton onClick={(e) => onPageChange(e, lastPage)} disabled={page >= lastPage} aria-label="last page">
          <LastPage />
        </IconButton>
      </div>
    );
  }

  return (
    <div className="container">
      {loading && <LoaderComponent />}
      <Modal isOpen={isOpen} onHandleClose={handleModalClose}>
        {selectModal()}
      </Modal>

      <div className="row mt-4">
        <div className="col">
          <h3>{searchTitle}</h3>
          <BreadCrumbs pathList={paths} />
        </div>

        {isAdd && (
          <div className="col-auto">
            <span className="addButton">
              <IconButton
                onClick={() => {
                  handleSelectBtn("add");
                  openAddModal();
                }}
              >
                <AddIcon />
              </IconButton>
            </span>
          </div>
        )}

        <div className="row">
          <div className="col-12">
            <div className="UserbudgetTable">
              <form onSubmit={handleSearchSubmit}>
                <FormTextInput
                  type="text"
                  className="searchBarUser mb-3"
                  placeholder="Search"
                  Value={searchValue.value}
                  onChangeText={handleSearch}
                  inputStyle={{ border: "none" }}
                  editable
                />
              </form>

              {rows.length ? (
                <>
                  <SearchMappingTable
                    isUpdate={isUpdate}
                    placeholder="Category Name"
                    data={rows}
                    mapableData={mapableData}
                    searchProp={["category_name"]}
                    handleChangeEdit={handleChangeEdit}
                  />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={CustomTablePaginationActions}
                  />
                </>
              ) : loading ? (
                <LoaderComponent />
              ) : (
                <NodataFound onClick={() => { handleSelectBtn("add"); openAddModal(); }} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
